require('./general/archive-selected');
require('./general/delete-selected');
require('./general/restore-selected');
require('./general/show-deleted');


// WEBPACK FOOTER //
// ./src/app/components/workflows/index.js